// extracted by mini-css-extract-plugin
module.exports = {"disable-scroll":"LocationDetailsRepeater_disable-scroll__1P04H","add":"LocationDetailsRepeater_add__DnYNu"};